import { render, staticRenderFns } from "./PartitionFormModal.vue?vue&type=template&id=c6c6e840&"
import script from "./PartitionFormModal.vue?vue&type=script&lang=js&"
export * from "./PartitionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports